import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImgCrop from 'antd-img-crop';
import {
  Checkbox, Upload,
  Select,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import H3FormInput from '@Uilib/h3FormInput';
import SellerActions from '@Actions/sellerActions';
import TenantActions from '@Actions/tenantActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import constants from '@Apis/constants';
import Helpers from '@Apis/helpers';
import H3ImageSelectorWithCrop from '../../../uilib/H3ImageSelectorWithCrop';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class CreateTenant extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      sellerName: '',
      gstin: '',
      pinCodeShipping: '',
      districtShipping: '',
      addressShipping: '',
      stateShipping: '',
      phone: '',
      email: '',
      fileList: [],
      toRecipients: [],
      checkedRecipients: true,
       selectedTenantId: null,
      uploadButton: (
        <div>
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>

        </div>
      ),
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {*&{district: *, state: *}}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.pincodeCity) {
      const city = props.pincodeCity;
      const cityState = props.pincodeState;
      props.setCityState(null, null);
      return {
        ...state, district: city, state: cityState, pinCodeShippingChange: false,
      };
    }
    return state;
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param {*} param0
   * @return
   */
  handleChange = ({ fileList }) => this.setState({ fileList });

  /**
   *
   * @param {*} param0
   * @return
   */
  handleChange = ({ fileList }) => this.setState({ fileList });

    /**
     *
     */
    addTenant = () => {
      this.setState({ formSubmitted: true });
      const {
        tenantName, phone, email, gstin, legalName, fileList, address, pinCode, district, state, addExistingProducts, addExistingVendors, toRecipients,  selectedTenantId,
      } = this.state;
      const {
        user, callback, createTenant,
      } = this.props;

      function checkvalue() {
        if ((addExistingVendors || addExistingProducts)) {
          if ( selectedTenantId) {
            return true;
          }
          return false;
        }

        return true;
      }

      if (tenantName && Helpers.validatePhoneNumber(phone) && Helpers.validateEmail(email) && legalName && Helpers.validateGstNumber(gstin) && address && district && state && pinCode && checkvalue()) {
        const payload = {
          tenant_name: tenantName,
          clone_tenant_id:  selectedTenantId,
          org_id: user?.tenant_info?.org_id,
          description: '',
          email,
          secondary_email: toRecipients,
          mobile: phone,
          is_active: true,
          legal_name: legalName,
          gst_number: gstin,
          logo: fileList?.[0]?.thumbUrl,
          add_existing_products: !!addExistingProducts,
          add_existing_vendors: !!addExistingVendors,
          default_billing_address: {
            address1: address,
            city: district,
            state,
            country: 'India',
            postal_code: pinCode,
          },
        };

        createTenant(payload, () => {
          callback();
        });
      }
    }

    /**
     *
     * @return {JSX.Element}
     */
    render() {
      const {
        createTenantLoading, getCityState, user,
      } = this.props;
      const {
        tenantName, phone, email, formSubmitted, addExistingProducts, addExistingVendors,  selectedTenantId,
        gstin, legalName, fileList, uploadButton, address, pinCode, district, state, toRecipients, checkedRecipients,
      } = this.state;

      const data = user?.user_tenants?.map((tenant) => ({
        label: tenant?.tenant_name,
        value: tenant?.tenant_id,
      }));

      return (
        <div className="ant-row">
          <div className="ant-col-md-12">
            <H3FormInput
              name="unit name"
              type="text"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ tenantName: event.target.value })}
              value={tenantName}
              label="Unit Name"
              maxlength="100"
              required
              disabled={createTenantLoading}
              showError={formSubmitted && !tenantName}
            />
          </div>
          <div className="ant-col-md-12">
            <H3FormInput
              name="legal name"
              type="text"
              containerClassName="orgInputContainer vendor__left-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ legalName: event.target.value })}
              value={legalName}
              label="Legal / Trade Name"
              required
              disabled={createTenantLoading}
              maxlength="50"
              showError={formSubmitted && !legalName}
            />
          </div>
          <div className="ant-col-md-12">
            <H3FormInput
              name="a valid phone number"
              type="text"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ phone: event.target.value })}
              value={phone}
              label="Phone"
              maxlength="50"
              required
              disabled={createTenantLoading}
              showError={formSubmitted && !Helpers.validatePhoneNumber(phone)}
            />
          </div>
          <div className="ant-col-md-12">
            <H3FormInput
              name="a valid GST number"
              type="text"
              containerClassName="orgInputContainer vendor__left-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState(
                { gstin: event.target.value, panNumber: event.target.value?.substr(2, 10) },
              )}
              value={gstin}
              required
              disabled={createTenantLoading}
              showError={formSubmitted && !Helpers.validateGstNumber(gstin)}
              label="GST Number"
            />
          </div>
          <div className="ant-col-md-12">
            <H3FormInput
              name="a valid email"
              type="text"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ email: event.target.value })}
              value={email}
              label="Email"
              maxlength="50"
              required
              disabled={createTenantLoading}
              showError={formSubmitted && !Helpers.validateEmail(email)}
            />
          </div>
          <div className="ant-col-md-12">
            <div
              className="orgInputContainer vendor__left-input"
              style={{ marginTop: '2px' }}
            >
              <label className="orgFormLabel">
                Secondary Email
              </label>
              <PRZSelect
                mode="tags"
                value={toRecipients}
                filterOption={false}
                maxTagCount="responsive"
                onChange={(value) => {
                  const recipients = [];
                  for (let i = 0; i < value?.length; i++) {
                    if (Helpers.validateEmail(value[i])) {
                      recipients.push(value[i]);
                    }
                  }
                  this.setState({ toRecipients: recipients });
                }}
                // disabled={
                //   createPurchaseOrderLoading
                //       || updatePoStatusLoading
                // }
                style={{
                  paddingTop: '2px',
                }}
              />
              {/* {formSubmitted && checkedRecipients && !toRecipients?.length && (
                <div className="formError">*Please enter at least one recipient</div>
              )} */}
            </div>
          </div>

          <div className="ant-col-md-12" />
          <div className="ant-col-md-24">
            <div className="orgInputContainer">
              <H3FormInput
                name="street address"
                type="text"
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                placeholder=""
                onChange={(event) => this.setState({ address: event.target.value })}
                value={address}
                label="Street Address"
                showError={formSubmitted && !address}
                disabled={createTenantLoading}
                required
              />
            </div>
          </div>
          <div className="ant-col-md-8">
            <H3FormInput
              name="a valid pincode"
              type="number"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => (event.target.value.length <= 6 ? this.setState({ pinCode: event.target.value }) : '')}
              onBlur={(event) => (event.target.value.length <= 6 ? getCityState(event.target.value) : '')}
              value={pinCode}
              label="Pin Code"
              required
              showError={formSubmitted && !pinCode}
              disabled={createTenantLoading}
            />
          </div>
          <div className="ant-col-md-8">
            <H3FormInput
              name="city"
              type="text"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ district: event.target.value })}
              value={district}
              label="City"
              showError={formSubmitted && !district}
              disabled={createTenantLoading}
              required
            />
          </div>
          <div className="ant-col-md-8">
            <H3FormInput
              name="state"
              type="text"
              containerClassName="orgInputContainer vendor__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ state: event.target.value })}
              value={state}
              label="State"
              disabled={createTenantLoading}
              showError={formSubmitted && !state}
              required
            />
          </div>
          <div className="ant-col-md-12">
            <div className="orgInputContainer  profile__right-input">
              <label className="orgFormLabel">
                Your Logo
              </label>
              <div className="ant-col-md-24">
                        <div className="settings__profile-wrapper-img">

                          <H3ImageSelectorWithCrop>
                            <Upload
                              action={constants.UPLOAD_FILE}
                              listType="picture-card"
                              fileList={fileList}
                              onChange={this.handleChange}
                              showUploadList={{ showPreviewIcon: false }}
                            >
                              {fileList?.length >= 1 ? null
                                : uploadButton}
                            </Upload>
                          </H3ImageSelectorWithCrop>
                        </div>
                      </div>
            </div>
          </div>
          <div className="ant-col-md-12" />
          <div className="ant-col-md-12">
            <div className="orgInputContainer create-Tenant-checkbox__wrapper vendor__right-input">
              <Checkbox disabled={createTenantLoading} checked={addExistingProducts} onChange={() => this.setState({ addExistingProducts: !addExistingProducts })} />
              {' '}
              <H3Text text="Add All Existing Products" className="orgFormLabel" />

            </div>
          </div>
          <div className="ant-col-md-12">
            <div className="orgInputContainer create-Tenant-checkbox__wrapper vendor__left-input">
              <Checkbox disabled={createTenantLoading} checked={addExistingVendors} onChange={() => this.setState({ addExistingVendors: !addExistingVendors })} />
              <H3Text text="Add All Existing Vendors" className="orgFormLabel" />

            </div>
          </div>
          {(addExistingProducts || addExistingVendors) && (
            <div className="ant-col-md-24">
              <div className="ant-col-md-14 mt-2">
                <div
                  className="orgInputContainer vendor__right-input"
                  style={{ marginTop: '2px' }}
                >
                  <label className="orgFormLabel">
                    Clone Settings From Tenant
                    <span style={{ color: 'red' }}>&nbsp;*</span>
                  </label>
                  <PRZSelect
                    value={ selectedTenantId}
                    filterOption={false}
                    maxTagCount="responsive"
                    onChange={(value) => {
                      this.setState({  selectedTenantId: value });
                    }}
                    style={{
                      paddingTop: '2px',
                    }}
                    showError={formSubmitted && ! selectedTenantId && (addExistingVendors || addExistingProducts)}
                    errorName="*Please select tenant to clone settings"
                    errorClassName="formError"
                  >
                    {data.map((option) => (
                      <Select.Option key={option.value} value={option.value}>
                        {option.label}
                      </Select.Option>
                    ))}
                  </PRZSelect>
                </div>
              </div>
            </div>
          )}

          <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Add Business Unit"
              onClick={() => this.addTenant()}
              isLoading={createTenantLoading}
              disabled={createTenantLoading}
              style={{
                width: '160px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      );
    }
}
const mapStateToProps = ({
  UserReducers, SellerReducers, TenantReducers,
}) => ({
  pincodeCity: SellerReducers.pincodeCity,
  pincodeState: SellerReducers.pincodeState,
  setCityStateError: SellerReducers.setCityStateError,
  user: UserReducers.user,
  cityStateLoading: SellerReducers.cityStateLoading,
  createTenantLoading: TenantReducers.createTenantLoading,
  tenants: TenantReducers.tenants,
});

const mapDispatchToProps = (dispatch) => ({
  createTenant: (payload, callback) => dispatch(TenantActions.createTenant(payload, callback)),
  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
});

CreateTenant.propTypes = {
  user: PropTypes.any,
  createTenantLoading: PropTypes.bool,
  callback: PropTypes.func,
  createTenant: PropTypes.func,
  pincodeCity: PropTypes.any,
  pincodeState: PropTypes.any,
  setCityState: PropTypes.func,
  getCityState: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateTenant));
